import { URLS } from "../../ApiConfig/Urls";
import instance, { instanceFile } from "../../ApiConfig";

const fetchDocumentType = async () => {
  try {
    // console.log("Hello", URLS.GetAdmin + URLS.GetDocumentType);
    const response = await instance.get(URLS.GetAdmin + URLS.GetDocumentType);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle Revenue");
  } catch (error) {
    throw error;
  }
};

const createDocument = async (createDriverDocument) => {
  //   console.log(URLS.GetAdmin + URLS.CreateDocument, createDriverDocument);
  return instanceFile
    .post(URLS.GetAdmin + URLS.CreateDocument, createDriverDocument)
    .then((response) => {
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error("Failed to Update Driver");
      }
    })
    .catch((error) => {
      console.error("Error updating Driver:", error);
      throw error;
    });
};

const fetchDriverDocument = async () => {
  try {
    // console.log("Hello", URLS.GetAdmin + URLS.GetDocumentType);
    const response = await instance.get(URLS.GetAdmin + URLS.GetDocumentType);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle Revenue");
  } catch (error) {
    throw error;
  }
};

export default {
  fetchDocumentType,
  createDocument,
  fetchDriverDocument,
};
